import { useTranslation } from 'react-i18next';
import './about.scss';
import aboutPrime from '../assets/background/about-prime.png';
import aboutPrime2 from '../assets/background/about-prime-2.png';
import aboutImageKOR from '../assets/background/about-image.png';
import aboutImageENG from '../assets/background/about-image-2.png';
import aboutImageJPN from '../assets/background/about-image-2.png';
import { motion } from 'framer-motion';
import { motionX, motionY } from 'src/core/animation';
import { useState } from 'react';
import translateSetting from 'src/core/translate-setting';

const About = () => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();

  let aboutImage = aboutImageKOR;
  if (curLng === 'ENG') {
    aboutImage = aboutImageENG;
  }
  if (curLng === 'JPN') {
    aboutImage = aboutImageJPN;
  }

  return (
    <section id="about" className="About">
      <img className="about-prime" src={aboutPrime} />
      <div className="content-box">
        <motion.div
          className="left-section"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: false, amount: 0.3 }}
          variants={motionX()}
        >
          <img className="prime-image-1" src={aboutImage} />
        </motion.div>
        <motion.div
          className="right-section"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: false, amount: 0.3 }}
          variants={motionX({ from: 50, to: 0 })}
        >
          <img className="prime-image-2" src={aboutPrime2} />
          <div className="big-text">{t('about.text-0')}</div>
          <div className="middle-text">{t('about.text-1')}</div>
          <div className="small-text">{t('about.text-2')}</div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
